<template>
	<div class="social">
		<a class="social__item" :href="$root.$link.vk" target="_blank">
			<svg class="social__item-icon">
				<use href="#svg-icon-vk"></use>
			</svg>
		</a>
		<a class="social__item" :href="$root.$link.tg" target="_blank">
			<svg class="social__item-icon">
				<use href="#svg-icon-tg"></use>
			</svg>
		</a>
	</div>
</template>
